import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: "Peace Through Music",
  date: new Date(2024, 3, 21),
  img: "/img/basil.jpeg",
  video: "/videos/basil.mp4",
  tracks: [
    {
      title: "Comfort Zone",
      src: "/songs/2024-05-05/comfort_zone.mp3",
      duration: 548.76,
    },
    {
      title: "(I See The) Ribbon Of Time",
      src: "/songs/2024-05-05/ribbon_of_time.mp3",
      duration: 1209.72,
    },
    {
      title: "Cinco De Mayo",
      src: "/songs/2024-05-05/cinco_de_mayo.mp3",
      duration: 779.76,
    },
    {
      title: "Hoochie Coochie Blues",
      src: "/songs/2024-05-05/hoochie_coochie_blues.mp3",
      duration: 612.336,
    },
    {
      title: "Toast And Marmalade",
      src: "/songs/2024-05-05/toast_and_marmalade.mp3",
      duration: 606.456,
    },
    {
      title: "(I Wanna Get A) Cheeseburger",
      src: "/songs/2024-05-05/cheeseburger.mp3",
      duration: 802.056,
    },
    {
      title: "Heads & Tails",
      src: "/songs/2024-05-05/heads_and_tails.mp3",
      duration: 468.384,
    },
    {
      title: "Darkness Never Sleeps",
      src: "/songs/2024-05-05/darkness_never_sleeps.mp3",
      duration: 789.816,
    },
    {
      title: "Precision Guided Beats",
      src: "/songs/2024-05-05/precision_guided_beats.mp3",
      duration: 1340.496,
    },
    {
      title: "Sound Check",
      src: "/songs/2024-05-05/sound_check.mp3",
      duration: 729.792,
    },
    {
      title: "Side Street Hustle",
      src: "/songs/2024-05-05/side_street_hustle.mp3",
      duration: 726.24,
    },
    {
      title: "You Got Me High",
      src: "/songs/2024-05-05/you_got_me_high.mp3",
      duration: 895.344,
    },
    {
      title: "Is This Music?",
      src: "/songs/2024-05-05/is_this_music.mp3",
      duration: 908.952,
    },
    {
      title: "Don't Be Afraid",
      src: "/songs/2024-05-05/dont_be_afraid.mp3",
      duration: 793.632,
    },
    {
      title: "Bird In A Bag",
      src: "/songs/2024-05-05/bird_in_a_bag.mp3",
      duration: 610.128,
    },
  ],
};
export default album;
